<template>
  <div class="grid gap-4 grid-cols-4 mb-6">
    <template v-if="loading">
      <div
        v-for="i in 4"
        :key="i"
        class="border border-gray-700 bg-gray-800 rounded-lg shadow-sm text-white animate-pulse"
      >
        <div class="flex justify-between items-center px-4 pt-4 pb-2">
          <div class="h-4 w-24 bg-gray-700 rounded mb-2" />
          <div class="h-4 w-6 bg-gray-700 rounded" />
        </div>
        <div class="px-4 pt-0 pb-4">
          <div class="h-8 w-20 bg-gray-700 rounded mb-2" />
          <div class="h-3 w-28 bg-gray-700 rounded" />
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="card in cards"
        :key="card.id"
        class="border border-gray-700 bg-gray-800 rounded-lg shadow-sm text-white"
      >
        <div class="flex justify-between items-center px-4 pt-4 pb-2">
          <h3 class="text-sm font-medium m-0 text-gray-200">{{ card.name }}</h3>
          <i :class="card.icon" class="text-base text-gray-400" />
        </div>
        <div class="px-4 pt-0 pb-4">
          <div class="text-2xl font-bold text-white">{{ card.count }}</div>
          <p class="text-xs text-gray-400">{{ card.description }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getNotificationInsights } from "@/api";
import dayjs from "dayjs";

export default {
  name: "CountPanel",
  props: {
    options: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      metrics: null,
      loading: true,
      defaultOptions: [
        {
          id: "activeRules",
          name: "Active Rules",
          icon: "fa fa-check-circle",
          count: 0,
          description: "of 0 total rules",
        },
        {
          id: "pendingAlerts",
          name: "Pending Alerts",
          icon: "fa fa-exclamation-circle",
          count: 0,
          description: "Awaiting acknowledgment",
        },
        {
          id: "escalatedToday",
          name: "Escalated Today",
          icon: "fa fa-arrow-up",
          count: 0,
          description: "Required supervisor attention",
        },
        {
          id: "falseAlerts",
          name: "False Alerts",
          icon: "fa fa-times-circle",
          count: 0,
          description: "This week",
        },
      ],
    };
  },
  computed: {
    cards() {
      if (!this.metrics || !this.metrics.metrics) {
        return this.options || this.defaultOptions;
      }
      const {
        enabled_rules = 0,
        total_rules = 0,
        no_feedback_count = 0,
        escalated_count = 0,
        false_feedback_count = 0,
      } = this.metrics.metrics;
      return [
        {
          id: "activeRules",
          name: "Active Rules",
          icon: "fa fa-check-circle",
          count: enabled_rules,
          description: `of ${total_rules} total rules`,
        },
        {
          id: "pendingAlerts",
          name: "Pending Alerts",
          icon: "fa fa-exclamation-circle",
          count: no_feedback_count,
          description: "Awaiting acknowledgment",
        },
        {
          id: "escalatedToday",
          name: "Escalated Today",
          icon: "fa fa-arrow-up",
          count: escalated_count,
          description: "Required supervisor attention",
        },
        {
          id: "falseAlerts",
          name: "False Alerts",
          icon: "fa fa-times-circle",
          count: false_feedback_count,
          description: "This week",
        },
      ];
    },
  },
  methods: {
    async fetchNotificationInsight() {
      this.loading = true;
      try {
        const data = await getNotificationInsights({
          metrics: [
            {
              name: "escalated_count",
              from: dayjs().subtract(1, "day").startOf("day").toISOString(),
              to: dayjs().startOf("day").toISOString(),
            },
            { name: "false_feedback_count" },
            { name: "enabled_rules" },
            { name: "total_rules" },
            { name: "no_feedback_count" },
          ],
        });
        this.metrics = data || null;
      } catch (error) {
        console.error("Failed to load notification insight", error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchNotificationInsight();
  },
};
</script>
